import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { UserGroupService } from '../userGroup.service';
import * as userGroupActions from './userGroup.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { UserGroup } from '../../_models/user_group';
import { UserZone } from '../../_models/user_zone';
import { Zone } from '../../_models/zone';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../state/app.actions';
import * as fromRoot from '../../state/app.reducer';

@Injectable()
export class UserGroupEffects {

    @Effect()
    loadUserGroup$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.LoadUserGroups),
        mergeMap((action: userGroupActions.LoadUserGroups) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadUserGroups =');
                // console.log(action.payload);
                return this.userGroupService.getUserGroups(action.payload).pipe(
                    map((userGroups: UserGroup[]) => {
                        this.changingLoading(false);
                        return new userGroupActions.LoadUserGroupsSuccess(userGroups);
                    }),
                    catchError(err => of(new userGroupActions.LoadUserGroupsFail(err)))
                )
            }
        )
    );

    // NOTA: Lanzar directamente otra acción sin llamar a ningún servicio.
    // @Effect()
    // loadUserGroupSuccess$ = this.actions$.pipe(
    //     ofType(userGroupActions.UserGroupActitonTypes.LoadUserGroupsSuccess),
    //     map((action: rootActions.ChangeLoading) => (new rootActions.ChangeLoading(false)))
    // );

    // NOTA: sin usar Loading ni ventanas de información.
    // @Effect()
    // updateUserGroup$: Observable<Action> = this.actions$.pipe(
    //     ofType(userGroupActions.UserGroupActitonTypes.UpdateUserGroup),
    //     map((action: userGroupActions.UpdateUserGroup) => action.payload),
    //     mergeMap(( userGroup: UserGroup) =>
    //         this.userGroupService.updateUserGroup(userGroup).pipe(
    //         map(updatedUserGroup => (new userGroupActions.UpdateUserGroupSuccess(updatedUserGroup))),
    //         catchError(err => of(new userGroupActions.UpdateUserGroupFail(err)))
    //     ))
    // );

    @Effect()
    updateUserGroup$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.UpdateUserGroup),
        mergeMap((action: userGroupActions.UpdateUserGroup) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateUserGroup =');
                // console.log(action.payload);
                return this.userGroupService.updateUserGroup(action.payload).pipe(
                    map((userGroup: UserGroup) => {
                        this.changingLoading(false);
                        // console.log('-->... Payload server UpdateUserGroup =');
                        // console.log(userGroup);
                        if (userGroup !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/userGroup', null, 'info');
                            return new userGroupActions.UpdateUserGroupSuccess(userGroup);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new userGroupActions.UpdateUserGroupFail('ERROR UpdateUserGroup effect.');
                        }
                    }),
                    catchError(err => of(new userGroupActions.UpdateUserGroupFail(err)))
                )
            }
        )
    );


    // @Effect()
    // createUserGroup$: Observable<Action> = this.actions$.pipe(
    //     ofType(userGroupActions.UserGroupActitonTypes.CreateUserGroup),
    //     map((action: userGroupActions.CreateUserGroup) => action.payload),
    //     mergeMap(( userGroup: UserGroup) =>
    //         this.userGroupService.createUserGroup(userGroup).pipe(
    //         map(createUserGroup => (new userGroupActions.CreateUserGroupSuccess(createUserGroup))),
    //         catchError(err => of(new userGroupActions.CreateUserGroupFail(err)))
    //     ))
    // );

    @Effect()
    CreateUserGroup$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.CreateUserGroup),
        mergeMap((action: userGroupActions.CreateUserGroup) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateUserGroup =');
                // console.log(action.payload);
                return this.userGroupService.createUserGroup(action.payload).pipe(
                    map((userGroupIn: UserGroup) => {
                        this.changingLoading(false);
                        // console.log('-->... Payload server CreateUserGroup =');
                        // console.log(userGroupIn);
                        if (userGroupIn !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/userGroup', null, 'info');
                            return new userGroupActions.CreateUserGroupSuccess(userGroupIn);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new userGroupActions.CreateUserGroupFail('ERROR CreateUserGroup effect.');
                        }
                    }),
                    catchError(err => of(new userGroupActions.CreateUserGroupFail(err)))
                )
            }
        )
    );

    // @Effect()
    // deleteUserGroup$: Observable<Action> = this.actions$.pipe(
    //     ofType(userGroupActions.UserGroupActitonTypes.DeleteUserGroup),
    //     map((action: userGroupActions.DeleteUserGroup) => action.payload),
    //     mergeMap(( userGroup: UserGroup) =>
    //         this.userGroupService.deleteUserGroup(userGroup).pipe(
    //         map(deleteUserGroupId => (new userGroupActions.DeleteUserGroupSuccess(deleteUserGroupId))),
    //         catchError(err => of(new userGroupActions.DeleteUserGroupFail(err)))
    //     ))
    // );

    @Effect()
    deleteUserGroup$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.DeleteUserGroup),
        mergeMap((action: userGroupActions.DeleteUserGroup) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteUserGroup =');
                // console.log(action.payload);

                return this.userGroupService.deleteUserGroup(action.payload).pipe(
                    map((userGroupId: bigint) => {
                        this.changingLoading(false);
                        // console.log('-->... Payload server DeleteUserGroup =');
                        // console.log(userGroupId);
                        if (userGroupId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new userGroupActions.DeleteUserGroupSuccess(userGroupId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new userGroupActions.DeleteUserGroupFail('ERROR DeleteUserGroup effect.');
                        }
                    }),
                    catchError(err => of(new userGroupActions.DeleteUserGroupFail(err)))
                )
            }
        )
    );

    // Para la carga de las user_zone.
    @Effect()
    loadUserZone$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.LoadUserZones),
        mergeMap((action: userGroupActions.LoadUserZones) => {
                this.changingLoading1(true);
                // console.log('-->... Payload LoadUserZone =');
                // console.log(action.payload);

                return this.userGroupService.getUserZones(action.payload).pipe(
                    map((zones: UserZone[]) => {
                        this.changingLoading1(false);
                        return new userGroupActions.LoadUserZonesSuccess(zones);
                    }),
                    catchError(err => of(new userGroupActions.LoadUserZonesFail(err)))
                )
            }
        )
    );

    @Effect()
    loadZone$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.LoadZones),
        mergeMap((action: userGroupActions.LoadZones) => {
                this.changingLoading2(true);
                // console.log('-->... Payload LoadZones =');
                // console.log(action.payload);

                return this.userGroupService.getZones(action.payload).pipe(
                    map((zones: Zone[]) => {
                        this.changingLoading2(false);
                        return new userGroupActions.LoadZonesSuccess(zones);
                    }),
                    catchError(err => of(new userGroupActions.LoadZonesFail(err)))
                )
            }
        )
    );

    @Effect()
    deleteUserZone$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.DeleteUserZone),
        mergeMap((action: userGroupActions.DeleteUserZone) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteUserZonep =');
                // console.log(action.payload);

                return this.userGroupService.deleteUserZone(action.payload).pipe(
                    map((userZoneId: bigint) => {
                        this.changingLoading(false);
                        // console.log('-->... Payload server DeleteUserZone =');
                        // console.log(userZoneId);
                        if (userZoneId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/userGroup-edit', null, 'info');
                            return new userGroupActions.DeleteUserZoneSuccess(userZoneId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new userGroupActions.DeleteUserZoneFail('ERROR DeleteUserZone effect.');
                        }
                    }),
                    catchError(err => of(new userGroupActions.DeleteUserZoneFail(err)))
                )
            }
        )
    );

    @Effect()
    CreateUserZone$ = this.actions$.pipe(
        ofType(userGroupActions.UserGroupActitonTypes.CreateUserZone),
        mergeMap((action: userGroupActions.CreateUserZone) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateUserZone =');
                // console.log(action.payload);
                return this.userGroupService.createUserZone(action.payload).pipe(
                    map((userZoneIn: UserZone) => {
                        this.changingLoading(false);
                        // console.log('-->... Payload server CreateUserZone =');
                        // console.log(userZoneIn);
                        if (userZoneIn !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/userGroup-edit', null, 'info');
                            return new userGroupActions.CreateUserZoneSuccess(userZoneIn);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new userGroupActions.CreateUserZoneFail('ERROR CreateUserGroup effect.');
                        }
                    }),
                    catchError(err => of(new userGroupActions.CreateUserZoneFail(err)))
                )
            }
        )
    );
    // -----------------------------

    constructor(private actions$: Actions,
                private userGroupService: UserGroupService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        // console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    changingLoading1(value: boolean) {
        // console.log('---->>>>.... Ejecutando prodData changingLoading1: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading1(value));
    }

    changingLoading2(value: boolean) {
        // console.log('---->>>>.... Ejecutando prodData changingLoading2: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading2(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        // console.log('---->>>>.... Ejecutando UserGroup Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }
}
